import { defineComponent as _defineComponent } from 'vue'
import UpdatedDate from '@/app/components/common/UpdatedDate.vue';
import { FutureCommissionSchedule } from '@/app/components/commissionSchedule';
import { CommissionsChart, SettlementScheduleCommissionChart } from 'ah-reports';
import { AuthorityType, ExportListType } from 'ah-api-gateways';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import { useAuthStore } from '@/app/store/authStore';
import { computed, ref } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommissionScheduleView',
  setup(__props) {

const authStore = useAuthStore();

const requestManager = useRequestManager().manager;

const services = getServices();

const futureCommission = ref<FutureCommissionSchedule>();

const timeStamp = ref<Date>();

function refreshData() {
  timeStamp.value = new Date();
  futureCommission.value?.loadData();
}

const canSeeWalletWithdrawCommissions = computed(() =>
  authStore.hasAuthorities(AuthorityType.VIEW_COMMISSION_WITHDRAWALS)
);

const dataDownloadState = computed(() => requestManager.requestStates.downloadData);

function downloadList(format: ExportListType) {
  requestManager.cancelAndNew('downloadData', services.trade.downloadFutureCommissionReport({}, format)).subscribe();
}

return { __sfc: true,authStore, requestManager, services, futureCommission, timeStamp, refreshData, canSeeWalletWithdrawCommissions, dataDownloadState, downloadList, UpdatedDate, FutureCommissionSchedule, CommissionsChart, SettlementScheduleCommissionChart, ListDownloadButton }
}

})